import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import * as logs from '../data/Logs';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            stack: ""
        };
    }

    componentDidCatch(error, info) {
        if (error != null &&
            info != null &&
            info.componentStack != null) {
            const message = error.toString();
            this.setState({ message: message, stack: info.componentStack });
            if (error.stack != null) {
                logs.log(logs.logLevels.error, error.stack, this.props.accountsState.authenticatedToken);
            }
        }
    }

    render() {
        if (this.state.message !== "") {
            return (
                <div>
                    <Alert color="danger">Something went wrong.</Alert>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        <br />
                        {this.state.message}
                        <br />
                        {this.state.stack}
                    </details>
                </div>
            );
        }
        return this.props.children;
    }
}

export default connect(
    state => ({
        accountsState: state.accounts
    }),
    null
)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js